import { z } from 'zod/v4-mini';

import { Schema, cz } from '@/utils/zodUtils.ts';

export type BirthLocation = {
  town: string;
  post_code: string;
};

export type IdentityValidation = {
  id: string;
  givenName: string;
  familyName: string;

  identityLastname: string;
  identityFirstnames: string[];
  gender: string;
  franceBirthLocation?: BirthLocation;
  franceBirthCountry?: string;
  birthDate: string;
};

export const birthLocationSchema: Schema<BirthLocation> = z.object({
  town: z.string(),
  post_code: z.string(),
});

export const identityValidationSchema: Schema<IdentityValidation> = z.object({
  givenName: z.string(),
  familyName: z.string(),
  identityLastname: z.string(),
  identityFirstnames: cz.forcedArray(z.string()),
  gender: z.string(),
  franceBirthLocation: cz.optional(birthLocationSchema),
  franceBirthCountry: z.string(),
  birthDate: cz.datetime(),
  id: z.string(),
});
